(() => {
  const closeMenus = (event) => {
    document.querySelectorAll('.tg-header-categories[open], .tg-mobile-gemstones[open]').forEach((menu) => {
      if (event.type === 'keydown') {
        if (event.key !== 'Escape') return;
        if (!menu.contains(document.activeElement)) return;
        event.preventDefault();
        menu.open = false;
        menu.querySelector(':scope > summary').focus();
      } else if (!menu.contains(event.target) || event.target.closest('a')) {
        menu.open = false;
      }
    });
  };
  document.addEventListener('click', closeMenus);
  document.addEventListener('keydown', closeMenus);
})();
